var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNz = function SvgNz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M11.968 12H12v-.032l-.032.032Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 6.26V0h-.002C5.372.001 0 5.373 0 12h6.26V8.474L9.787 12h2.182l.032-.032V9.786L8.474 6.261H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.071 1.565A12.057 12.057 0 0 0 1.565 6.07V12h3.13V4.695H12v-3.13H6.071Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 10.525 7.738 6.26H6.262L12 12.001v-1.476ZM20.78 8.905l.26.797h.838l-.678.492.259.798-.678-.493-.678.493.259-.798-.678-.492h.838l.259-.797ZM17.785 14.644l.389 1.195h1.257l-1.017.74.389 1.195-1.018-.739-1.017.739.389-1.196-1.017-.739h1.257l.388-1.195ZM17.899 5.252l.324.996h1.047l-.847.616.323.997-.847-.616-.848.616.324-.997-.848-.616h1.048l.324-.996ZM15.015 8.87l.388 1.196h1.258l-1.018.739.39 1.195-1.018-.739-1.017.74.388-1.196-1.017-.74h1.257l.389-1.195Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgNz;